import * as React from 'react'

const styles = require('./styles')

export interface ProgressProps {
  currentStep: number
  totalNumberOfSteps: number
}

export const Progress = (props: ProgressProps) => (
  <div className={styles.progress}>
    Step <strong>{props.currentStep}</strong> of <strong>{props.totalNumberOfSteps}</strong>
  </div>
)
